import { useDisclosure } from '@chakra-ui/hooks'
import React from 'react'
import useFetch, { CachePolicies } from 'use-http'

import PublicPasswordModal from "../../components/PublicLink/PublicLinkPasswordModal"


const PublicLinkPasswordLayout = (): React.ReactElement => {
  const {
    isOpen: isPasswordModalOpen,
    onClose: onPasswordModalClose,
    onOpen: onPasswordModalOpen,
  } = useDisclosure({
    isOpen: true
  })

  return (
    <PublicPasswordModal
      isOpen={isPasswordModalOpen}
      onClose={onPasswordModalClose}
    />
  )
}

export default PublicLinkPasswordLayout